import {post, get, del} from '@/utils/request'

// 获取设备列表
export function getMPosListAPI(data) {
    return post({
        data,
        url: 'resource/mpos/list'
    })
}
// 删除记录
export function deleteMPosAPI(id) {
    return del({
        url: `resource/mpos/${id}`
    })
}

// 话费导入
export function importMposDataAPI(data) {
    return post({
        data,
        url: 'resource/mpos/batch'
    })
}